import { ReactNode } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

type DragDropItem<Item> = Item & {
  id: string | number;
};

export interface DragResult {
  source: {
    index: number;
  };
  destination: {
    index: number;
  };
}

interface DragDropProps<Item> {
  onDragEnd: (result: DragResult) => void;
  items: DragDropItem<Item>[];
  children: (item: DragDropItem<Item>) => ReactNode;
  // Any unique string for those area where dragdrop is used (e.g section-editor-form)
  droppableId: string;
  disabledToDragIds?: Array<string | number>;
}

export const DragDrop = <Item,>({
  onDragEnd,
  items,
  children,
  droppableId,
  disabledToDragIds = [],
}: DragDropProps<Item>) => {
  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId={`${droppableId}-droppable`}>
        {(droppableProvided) => (
          <div {...droppableProvided.droppableProps} ref={droppableProvided.innerRef}>
            {items?.map((item, index) => (
              <Draggable
                key={item.id}
                draggableId={item.id}
                index={index}
                isDragDisabled={disabledToDragIds.includes(item.id)}
              >
                {(draggableProvided) => (
                  <div
                    ref={draggableProvided.innerRef}
                    {...draggableProvided.draggableProps}
                    {...draggableProvided.dragHandleProps}
                  >
                    {children(item)}
                  </div>
                )}
              </Draggable>
            ))}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};
